import store from '@/store/index.js'
let dic = store.state.dic;

export default function Configs(that) {

    const searchItems = [
        {
            label: "组织名称",
            span: 8,
            placeholder: '请输入组织名称',
            model: "name"
        },
        // {
        //     label: "上级机构",
        //     span: 8,
        //     placeholder: '上级机构Id',
        //     model: "parentId"
        // }
    ]
    const tableColumns = [
        // {
        //     label: "序号",
        //     prop: "studentId",
        //     align: "center",
        //     show: true
        // },
        {
            label: "机构名称",
            prop: "name",
            align: "center",
            show: true
        },
        {
            label: "父级机构",
            prop: "parentName",
            align: "center",
            show: true
        },
        {
            label: "操作",
            name: "contr",
            align: "center",
            show: true,
            width: "200px"
        }
    ]

    return {
        searchItems,
        tableColumns
    }
}
